import React from 'react';
import { Form, Select } from 'antd';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Input reutilizable de destinatarios (to/cc) con chips. Valida formato de email.
function EmailRecipients() {
  const validateEmails = (_rule, value) => {
    if (!value || value.length === 0) return Promise.resolve();
    const bad = value.filter((v) => !EMAIL_RE.test(v));
    return bad.length
      ? Promise.reject(new Error(`Email inválido: ${bad.join(', ')}`))
      : Promise.resolve();
  };
  return (
    <>
      <Form.Item
        label="Para"
        name="to"
        rules={[
          { required: true, message: 'Agregue al menos un destinatario' },
          { validator: validateEmails },
        ]}
      >
        <Select mode="tags" tokenSeparators={[',', ' ', ';']} placeholder="correo@cliente.cl" />
      </Form.Item>
      <Form.Item label="CC" name="cc" rules={[{ validator: validateEmails }]}>
        <Select mode="tags" tokenSeparators={[',', ' ', ';']} placeholder="opcional" />
      </Form.Item>
    </>
  );
}

export default EmailRecipients;
